import {UPDATE_CHANNEL} from './../const';

module.exports = function(parameter) {
  return { type: UPDATE_CHANNEL, parameter };
};



// WEBPACK FOOTER //
// ./src/actions/channels/update_channel.js